<template>
  <div class="container-fluid">  
    <BarreFiltres :filtres="filtres" @appliquer-filtre="appliquerFiltre($event)" />
    <div class="flex-center-center">
      <div class="card col-12 col-xl-10 col-xxl-8 height-responsive">
        <div class="card-header" >
          Espace Fournisseur Agap'Pro - Ami2 par Entegra - Documentation
        </div>
        <div class="card-container height-responsive-body height-responsive-1b">
          <div class="card-body">
            <section id="sectionPrincipale">
              <p>Ce site vous permet de gérer vos propositions de tarifs ainsi que l'ensemble de vos informations</p>  
              <div class="container mb-3">
                <img class="border-black border-rounded w-100" src="../../assets/images/documentation/generale/menu.png" alt="Image création commande">
              </div>
              <p>Depuis le menu "Tarifs", vous retrouverez, pour une date de mise à jour, l'ensemble de vos cotations, classées par famille de produits.</p>
              <p>Depuis le menu "Documents", vous avez accès à vos documents spéciaux, il s'agit d'un lien vers l'ancien espace fournisseur.</p>
              <p>Sur la droite du menu, vous trouverez plusieurs icônes :</p>
              <ul class="puces">
                <li>Votre nom de fournisseur. Si votre compte personnel est rattaché à plusieurs fournisseurs, vous pouvez choisir avec lequel travailler ici.</li>
                <li><i class="ft-bell mr-2"></i>Informations des mises à jour du site.</li>              
                <li><i class="ft-user mr-2"></i>Vos informations générales, lien vers l'ancien espace fournisseur.</li>              
                <li><i class="ft-log-out mr-2"></i>Déconnexion du site.</li>              
              </ul>
            </section>
          </div>
        </div>
      </div>     
    </div>
  </div>
</template>
  
  <script>
  
  import BarreFiltres from '@/components/Divers/BarreFiltres'
  
  export default {
    name: "AideGenerale",
    components: {
      BarreFiltres
    },
    data() {
      return {
        filtres: {
          sections: {
            label: "Choix de votre recherche...",
            champ: "select",
            options: [           
              { valeur: 'sectionPrincipale', texte: 'Menu principal' },
            ],
            selection: [],
            filtrer(contexte) {
              let filtre = contexte.filtres.sections
              if (filtre.selection) {
                let sectionSelectionnee = document.getElementById(filtre.selection.valeur);
                if (sectionSelectionnee) {
                  sectionSelectionnee.scrollIntoView();
                }  
              }            
            }
          },
          // Appeler "this.filtres.initialiser(this)" dans mounted() => génère le tableau de filtres utilisés pour afficher les filtres dans la barre de filtres
          barreGauche: [],
          barreDroite: [],
          initialiser(contexte) {
            contexte.filtres.barreGauche = [ contexte.filtres.sections ]
          }
        },      
      }
    }, 
    methods: {
      appliquerFiltre(filtrer) {
        // Nécessaire pour faire fonctionner les filtres de la barre de filtres
        filtrer(this)
      },   
    },
    mounted() {
      this.filtres.initialiser(this)
    }
  }
  </script>
  